import {
	BOTTOM_LETTERS_INPUT,
	BOTTOM_LETTERS_WRAPPER_SELECTOR,
	KNIT_BEANIE_TEXT,
	MICROSCRIPT_TEXT_INPUT,
	MICRO_BEANIE_TEXT,
	MICRO_CHECKBOX,
	OUTLINE_WRAPPER_SELECTOR,
	SCRIPT_TEXT,
	SECONDARY_LETTERS,
	SECONDARY_LETTERS_WRAPPER_SELECTOR,
} from "../4-one-of-one/_selectors";
import { OUTLINE_INPUT, SCRIPT_TEXT_NOT_SELECT } from "../constants/selectors";
import disableInput from "../dom/disableInput";
import hideOutline from "../dom/hideOutline";
import resetInputValue from "../dom/resetInputValue";
import selectAllElements from "../dom/selectAllElements";
import selectSingleElement from "../dom/selectSingleElement";
import { showOrHideElements } from "../dom/showOrHideElements";

export default function knitBeanieStyleButtonHandleClick() {
	hideOutline();
	showOrHideElements({
		elements: selectAllElements<HTMLDivElement>(KNIT_BEANIE_TEXT),
		show: true,
	});
	showOrHideElements({
		elements: [
			...selectAllElements(SCRIPT_TEXT),
			selectSingleElement(OUTLINE_WRAPPER_SELECTOR),
			selectSingleElement(MICRO_BEANIE_TEXT),
		],
		show: false,
	});
	disableInput(
		selectSingleElement<HTMLInputElement>(SECONDARY_LETTERS),
		selectSingleElement<HTMLDivElement>(SECONDARY_LETTERS_WRAPPER_SELECTOR),
	);
	disableInput(
		selectSingleElement<HTMLInputElement>(BOTTOM_LETTERS_INPUT),
		selectSingleElement<HTMLDivElement>(BOTTOM_LETTERS_WRAPPER_SELECTOR),
	);
	resetInputValue(selectSingleElement<HTMLInputElement>(MICRO_CHECKBOX));
	resetInputValue(selectSingleElement<HTMLInputElement>(SCRIPT_TEXT_NOT_SELECT));
	resetInputValue(selectSingleElement<HTMLInputElement>(MICROSCRIPT_TEXT_INPUT));
	resetInputValue(selectSingleElement<HTMLInputElement>(OUTLINE_INPUT));
}
